var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForMinorsFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.516602 29.3979C0.516602 13.1619 13.6785 0 29.9145 0C46.1505 0 59.3124 13.1619 59.3124 29.3979C59.3124 45.6339 46.1505 58.7958 29.9145 58.7958C13.6785 58.7958 0.516602 45.6339 0.516602 29.3979ZM29.9145 14.6989C37.9989 14.6989 44.6134 21.3135 44.6134 29.3979C44.6134 36.7474 39.2851 42.9944 31.9356 44.0968V33.6238H35.4266L36.1615 29.3979H32.1193V26.6418C32.1193 25.5394 32.6705 24.437 34.5079 24.437H36.3453V20.7623C36.3453 20.7623 34.6916 20.3948 33.038 20.3948C29.7307 20.3948 27.5259 22.4159 27.5259 26.0906V29.3979H23.8512V33.6238H27.5259V43.9131C20.5439 42.8107 15.2155 36.7474 15.2155 29.3979C15.2155 21.3135 21.8301 14.6989 29.9145 14.6989Z",
    fill: "#E97737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForMinorsFb);
export default __webpack_public_path__ + "static/media/forMinors-fb.e969b43851bc0bd5f28b891b9b486717.svg";
export { ForwardRef as ReactComponent };